import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import { H4 } from '@blueprintjs/core';

class ALRSpecPopup extends React.PureComponent {

  state = {
     svgIsReady:false,
     svgData:{}
  }

  componentDidMount() {
    const endpoint = "/query2svg.ajax.php";
    fetch(
        process.env.REACT_APP_API_BASE + endpoint, {
            credentials: process.env.REACT_APP_CREDENTIALS,
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify({query:this.props.alr}),
        }
    )
    .then((res) => {
        if (res.status !== 200) {
            console.log(`Issue reaching ${endpoint}`);
            return;
        }
        res.json().then((data) => {
            this.setState({ svgIsReady: true, svgData:data });   
        });
    });
  }

  render() {
        const { t, data, realization } = this.props;

        if (data) {
            let xyTab=[];
            const keys=Object.keys(data).sort();
            for (var i=0;i<keys.length;i++) {
                var key=keys[i];
                xyTab.push({x:key,y:data[key]});
            }
           // prep data for the chart
            const series = [{
                name:t('specificity'),
                data:xyTab
            }];
            const options = {
                chart: {
                type: 'bar',
                height: 350
                },
                plotOptions: {
                    bar: {
                        columnWidth: '80%',
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                yaxis: {
                    title: {
                        text: t('specificity'),
                    },
                    labels: {
                        formatter: function (y) {
                        return y.toFixed(0);
                        }
                    }
                },
                xaxis: {
                    type: 'text',
                    labels: {
                        rotate: -90
                    }
                }
            };

            return (
                <>
                
                    <Chart options={options} series={series} type="bar" height={350} />
                    <br/>
                    <center><H4>{realization}</H4></center>
                    { this.state.svgIsReady && 
                        <center><div dangerouslySetInnerHTML={{__html:this.state.svgData.svg}}></div></center>
                    }
                </>
               
            );
        } else {
            return (<></>)
        }
    }
}

ALRSpecPopup.propTypes = {
        // see prepCoocData for an example
        data: PropTypes.arrayOf(PropTypes.number),
        alr : PropTypes.string,
        realization : PropTypes.string,
};

export default withTranslation()(ALRSpecPopup);
